import { useContext } from "react";
import TemplateContext from "./TemplateContext";

const useTemplates = () => {
    return useContext(TemplateContext);
}

export default useTemplates;